import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined, AppleFilled, CheckCircleFilled } from '@ant-design/icons';
import { Button } from 'antd';

import step1 from '../../../assets/images/mac-guide/step-1.png';
import step2 from '../../../assets/images/mac-guide/step-2.png';
import step3 from '../../../assets/images/mac-guide/step-3.png';
import step4 from '../../../assets/images/mac-guide/step-4.png';
import step5 from '../../../assets/images/mac-guide/step-5.png';
import step6 from '../../../assets/images/mac-guide/step-6.png';
import step7 from '../../../assets/images/mac-guide/step-7.png';

const STEPS = [
  {
    img: step1,
    title: 'Download the App',
    desc: 'Click the Mac App download button. Your browser will download a .dmg file (e.g. Picbot_Mac_Desktop_App.dmg). Wait for "Done" to appear in the browser download bar.',
  },
  {
    img: step2,
    title: 'Locate the Downloaded File',
    desc: 'Open your Downloads folder in Finder. You will see the Picbot DMG file listed under "Today". Double-click it to open.',
  },
  {
    img: step3,
    title: 'Drag PicBot to Applications',
    desc: 'A window opens showing the PicBot icon and an Applications folder shortcut. Drag the PicBot icon into the Applications folder to install it.',
  },
  {
    img: step4,
    title: 'Confirm in Applications',
    desc: 'Open your Applications folder and confirm PicBot appears in the list. You can now eject the DMG from the left sidebar.',
  },
  {
    img: step5,
    title: 'Open System Settings',
    desc: 'Click the Apple menu in the top-left corner and select "System Settings…".',
  },
  {
    img: step6,
    title: 'Allow PicBot in Privacy & Security',
    desc: 'In System Settings, go to Privacy & Security. Scroll down to the Security section. You will see "PicBot was blocked to protect your Mac." Click "Open Anyway".',
  },
  {
    img: step7,
    title: 'Confirm and Open',
    desc: 'A confirmation dialog appears. Click "Open Anyway" to launch PicBot. macOS will remember this choice — you won\'t be prompted again.',
  },
];

export default function MacGuide() {
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: 780, margin: '0 auto', padding: '32px 16px 64px' }}>
      {/* Header */}
      <div className="d-flex align-items-center gap-3 mb-4">
        <Button
          type="text"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
          style={{ padding: '4px 8px' }}
        />
        <div>
          <h2 className="mb-0" style={{ fontSize: 22, fontWeight: 700, color: '#131517' }}>
            <AppleFilled className="me-2" style={{ fontSize: 20 }} />
            PicBot Mac Desktop App — Setup Guide
          </h2>
          <p className="mb-0 mt-1" style={{ fontSize: 13, color: '#595C5C' }}>
            Follow these steps to install and open PicBot on your Mac
          </p>
        </div>
      </div>

      {/* Steps */}
      <div className="d-flex flex-column gap-4">
        {STEPS.map((step, i) => (
          <div
            key={i}
            className="card custom-card"
            style={{ overflow: 'hidden', border: '1px solid #EFEFF0' }}
          >
            <div className="d-flex align-items-center gap-2 mb-3">
              <div
                className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                style={{ width: 30, height: 30, background: '#131517', color: '#fff', fontWeight: 700, fontSize: 13 }}
              >
                {i + 1}
              </div>
              <h6 className="mb-0 fw-600" style={{ fontSize: 15, color: '#131517' }}>{step.title}</h6>
            </div>

            <p style={{ fontSize: 14, color: '#595C5C', lineHeight: 1.6 }} className="mb-3">
              {step.desc}
            </p>

            <div
              className="rounded overflow-hidden"
              style={{ border: '1px solid #EFEFF0', background: '#F9F9F9', textAlign: 'center' }}
            >
              <img
                src={step.img}
                alt={`Step ${i + 1} — ${step.title}`}
                style={{ maxWidth: '100%', maxHeight: 420, objectFit: 'contain', display: 'block', margin: '0 auto' }}
              />
            </div>
          </div>
        ))}
      </div>

      {/* Done card */}
      <div
        className="rounded p-4 mt-4 d-flex align-items-center gap-3"
        style={{ background: '#f0fdf4', border: '1px solid #bbf7d0' }}
      >
        <CheckCircleFilled style={{ fontSize: 28, color: '#16a34a', flexShrink: 0 }} />
        <div>
          <p className="mb-1 fw-600" style={{ color: '#15803d', fontSize: 15 }}>You're all set!</p>
          <p className="mb-0" style={{ fontSize: 13, color: '#166534' }}>
            PicBot is now installed and ready to use on your Mac. Launch it anytime from your Applications folder or Dock.
          </p>
        </div>
      </div>
    </div>
  );
}
